var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7812 6.34375C11.7812 4.1001 9.96239 2.28125 7.71875 2.28125C5.4751 2.28125 3.65625 4.1001 3.65625 6.34375C3.65625 8.58739 5.4751 10.4062 7.71875 10.4062C9.96239 10.4062 11.7812 8.58739 11.7812 6.34375Z",
    stroke: "#423F5A",
    strokeWidth: 1.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03125 16.0938C2.03125 12.9526 4.57763 10.4062 7.71875 10.4062C8.59105 10.4062 9.41744 10.6026 10.1562 10.9536",
    stroke: "#423F5A",
    strokeWidth: 1.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 16.5C15.3801 16.5 16.0389 16.0881 16.3889 15.4766M14.625 16.5C13.8699 16.5 13.2111 16.0881 12.8611 15.4766M14.625 16.5V17.7188M16.3889 15.4766L17.4688 16.0936M16.3889 15.4766C16.5591 15.1796 16.6562 14.8355 16.6562 14.4688C16.6562 14.1019 16.559 13.7577 16.3889 13.4607M12.8611 15.4766L11.7812 16.0936M12.8611 15.4766C12.6909 15.1796 12.5938 14.8355 12.5938 14.4688C12.5938 14.1019 12.691 13.7577 12.8611 13.4607M14.625 12.4375C15.38 12.4375 16.0388 12.8494 16.3889 13.4607M14.625 12.4375C13.87 12.4375 13.2112 12.8494 12.8611 13.4607M14.625 12.4375V11.2188M16.3889 13.4607L17.4688 12.8436M12.8611 13.4607L11.7812 12.8436",
    stroke: "#423F5A",
    strokeWidth: 1.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersRole);
export default __webpack_public_path__ + "static/media/users-role.4398a4bd21c9835c57669a17ebb234a9.svg";
export { ForwardRef as ReactComponent };